import Vue from 'vue'
import VueComponents from '@ctvoicer/vuecomponents'
import '@ctvoicer/vuecomponents/dist/vue-components.css'

const options = {}

const buefyOptions = {
  defaultIconPack: 'fas',
  defaultDialogCancelText: 'Cancelar',
  defaultDayNames: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
  defaultMonthNames: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro']
}

Vue.use(VueComponents, { options, buefyOptions })
